import { render, staticRenderFns } from "./simple-table.vue?vue&type=template&id=88b6b7ca&scoped=true&"
import script from "./simple-table.vue?vue&type=script&lang=js&"
export * from "./simple-table.vue?vue&type=script&lang=js&"
import style0 from "./simple-table.vue?vue&type=style&index=0&id=88b6b7ca&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b6b7ca",
  null
  
)

export default component.exports